export const LITTER_SPECIES = ["Dog", "Cat", "Bird", "Rabbit", "Reptile", "Small animal", "Livestock", "Other"];
const EGG_LAYERS = ["Bird", "Reptile"];

export const kindFor = (species) => (EGG_LAYERS.includes(species) ? "clutch" : "litter");
const EN = { lt_kind_litter: "Litter", lt_kind_clutch: "Clutch", lt_st_expected: "Expected", lt_st_eggs: "Eggs expected", lt_st_born: "Born", lt_st_hatched: "Hatched", lt_st_closed: "Closed" };
const en = (k) => EN[k];

export const kindLabel = (kind, t = en) => t(kind === "clutch" ? "lt_kind_clutch" : "lt_kind_litter");

export const statusLabel = (status, kind, t = en) => {
  if (status === "arrived") return t(kind === "clutch" ? "lt_st_hatched" : "lt_st_born");
  if (status === "closed") return t("lt_st_closed");
  return t(kind === "clutch" ? "lt_st_eggs" : "lt_st_expected");
};

export const STATUS_CLS = {
  upcoming: "bg-amber-100 text-amber-800",
  arrived: "bg-emerald-100 text-emerald-700",
  closed: "bg-slate-200 text-slate-600",
};

export const fmtDay = (d, lang) => (d ? new Date(`${d}T12:00:00`).toLocaleDateString(lang === "fr" ? "fr-CA" : "en-CA", { month: "short", day: "numeric", year: "numeric" }) : "");

export const emptyLitter = {
  species: "Dog", kind: "", breed: "", title: "", status: "upcoming", expected_date: "", ready_date: "",
  expected_count: "", price_note: "", description: "", photo: "", waitlist_open: true, waitlist_cap: "",
};

const SPECIES_FR = { Dog: "Chien", Cat: "Chat", Bird: "Oiseau", Rabbit: "Lapin", Reptile: "Reptile", "Small animal": "Petit animal", Livestock: "Bétail", Other: "Autre" };
export const speciesLabel = (s, lang) => (lang === "fr" ? SPECIES_FR[s] || s : s);

// "Due in 12 days" countdown for upcoming litters; null once arrived or without a date
export const dueIn = (l, lang) => {
  if (!l?.expected_date || l.arrived || l.status !== "upcoming") return null;
  const [y, m, d] = l.expected_date.split("-").map(Number);
  const now = new Date();
  const days = Math.round((Date.UTC(y, m - 1, d) - Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000);
  if (days < 0) return null;
  const fr = lang === "fr";
  const clutch = l.kind === "clutch";
  if (days === 0) return fr ? (clutch ? "Éclosion aujourd'hui!" : "Prévue aujourd'hui!") : (clutch ? "Hatching today!" : "Due today!");
  if (days === 1) return fr ? (clutch ? "Éclosion demain" : "Prévue demain") : (clutch ? "Hatching tomorrow" : "Due tomorrow");
  return fr ? `${clutch ? "Éclosion" : "Prévue"} dans ${days} jours` : `${clutch ? "Hatching" : "Due"} in ${days} days`;
};
